import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CardSetTransformationService, CoreService, DataService, DialogService, SaveDataRequest, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, POP_UP_CODES, SAVE_RESULT_STATUS, SERVER_ERROR_POP_UP_CODES } from 'src/app/constants/app-data.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';

@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.scss']
})
export class OrganisationComponent extends BaseCardSetDetailComponent implements OnInit {

  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;

  id = '';
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  templateId: number = TEMPLATES.organisation;
  versionNo: number = VERSIONS.latest;
  activeDialog: string;
  editing = false;

  constructor(
    private route: ActivatedRoute,
    protected router: Router,
    private errorService: ErrorService,
    private coreService: CoreService,
    private dataService: DataService,
    protected dialogService: DialogService,
    private spinnerService: SpinnerService,
    protected appDataService: AppDataService
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.id = id;
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getOrganisationConfigAndResponse;
        this.editing = true;
      }
    });

    this.coreService.conditionFunctions['isEditing'] = () => this.editing;
  }

  formLoaded($event) {
    if (this.baseForm && this.baseForm.model) {
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
    }
  }

  save(event: any) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: false
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  private saveData(request: SaveDataRequest) {
    this.spinnerService.showSpinner();
    this.dataService.saveData(API_ENDPOINTS.organisation.save, request)
      .pipe(
        take(1),
        this.errorService.errorHandler(),
        finalize(() => this.spinnerService.hideSpinner())
      )
      .subscribe(data => {
        if (data?.status === SAVE_RESULT_STATUS.success) {
          if (SERVER_ERROR_POP_UP_CODES.saveOrganisation.includes(data.message)) {
            this.activeDialog = data.message;
          }
          else {
            this.id = data.id;
            this.activeDialog = POP_UP_CODES.common.saveSuccessful;
          }
          this.dialogService.showDialog(this.activeDialog);
        }
      });
  }

  cancel(event: any) {
    this.navigateBackToDashboard();
  }

  dialogSubmitted(event: any) {
    if (this.activeDialog === POP_UP_CODES.common.saveSuccessful) {
      this.navigateBackToDashboard(true);
    }
  }

  private navigateBackToDashboard(ignoreUnsavedChanges = false): void {
    this.navigate(['/', ROUTE_CONSTANTS.organisation.list], ignoreUnsavedChanges);
  }
}

